export default "__VITE_ASSET__Bely40K4__"